import script from "./AllergiesInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllergiesInformation.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__